module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAMAAAAhfX2ZAAAAAXNSR0IB2cksfwAAAEVQTFRFAAAAIHX/H3b/H3b/H3b/Hnf/IHj/Hnb/IHX/H3b/H3b/IHD/IHj/H3b/IHb/IHf/IHb/H3b/IHb/Hnb/H3X/H3b/HnX/jsnCsAAAABd0Uk5TAGDP/++fIKAw39AQQPBQkIDAcI+/4LCCE16XAAAAXElEQVR4nDWN6xaAIAiDVzO10FK7vP+jBlrfD86ADQBMM93ioQQaLuqMgxXYyCApkzt0IMBBFmivtko2S7nz0p2H/2IB3aZkOyzZZLEXaKpu6dJO70MhseLniVZfxn8CiJpNpb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/search-gps.png
// module id = 903
// module chunks = 0